document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.recursos-grid');
    const dots = document.querySelectorAll('.dot');
    let currentIndex = 0;

    // Función para actualizar los dots
    function updateDots() {
        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === currentIndex);
        });
    }

    // Función para mover el carousel
    function moveCarousel(index) {
        const cardWidth = carousel.querySelector('.card').offsetWidth;
        const scrollPosition = index * (cardWidth + 16); // 16px es el gap
        carousel.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
        });
        currentIndex = index;
        updateDots();
    }

    // Event listeners para los dots
    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            moveCarousel(index);
        });
    });

    // Detectar el final del scroll para actualizar los dots
    carousel.addEventListener('scroll', () => {
        const cardWidth = carousel.querySelector('.card').offsetWidth;
        const scrollPosition = carousel.scrollLeft;
        const newIndex = Math.round(scrollPosition / (cardWidth + 16));
        
        if (newIndex !== currentIndex) {
            currentIndex = newIndex;
            updateDots();
        }
    });

    // Inicializar el primer dot como activo
    updateDots();
}); 